(() => {
  let loaded = false;
  const preload = () => {
    if (loaded) return;
    loaded = true;
    document
      .querySelectorAll('.header__nav--group-card img[loading="lazy"], .menu-card-group img[loading="lazy"]')
      .forEach(img => {
        img.loading = 'eager';
      });
  };
  const triggers = document.querySelectorAll('.header__nav, header-drawer .drawer__button');
  triggers.forEach(el => {
    el.addEventListener('pointerenter', preload, { once: true });
    el.addEventListener('pointerdown', preload, { once: true });
    el.addEventListener('touchstart', preload, { once: true, passive: true });
    el.addEventListener('focusin', preload, { once: true });
  });
})();
